"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchFavouriteEventsIdsSaga = fetchFavouriteEventsIdsSaga;
exports.createFavouriteEventSaga = createFavouriteEventSaga;
exports.deleteFavouriteEventSaga = deleteFavouriteEventSaga;
exports.deleteFavouriteEventsByIdsSaga = deleteFavouriteEventsByIdsSaga;
exports.deleteFavouriteEventsSaga = deleteFavouriteEventsSaga;
exports.favouritesProviderSaga = favouritesProviderSaga;
const effects_1 = require("redux-saga/effects");
const errors_1 = require("../../utils/errors");
const api_1 = require("../../api/favorite-events/api");
const slice_1 = require("./slice");
function* fetchFavouriteEventsIdsSaga() {
    try {
        const { data: fevoriteEventsList } = yield (0, effects_1.call)(api_1.getFavoriteEvents);
        yield (0, effects_1.put)(slice_1.favouritesProviderActions.fetchFavouriteEventsIdsSuccess(fevoriteEventsList));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching favourite events', error);
        yield (0, effects_1.put)(slice_1.favouritesProviderActions.fetchFavouriteEventsIdsError(error));
    }
}
function* createFavouriteEventSaga(action) {
    const { payload: reqData } = action;
    try {
        yield (0, effects_1.call)(api_1.createFavoriteEvent, reqData);
        yield (0, effects_1.put)(slice_1.favouritesProviderActions.createFavouriteEventSuccess());
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while creating a favourite event', error);
        yield (0, effects_1.put)(slice_1.favouritesProviderActions.createFavouriteEventError({
            errorData: error,
            reqData,
        }));
    }
}
function* deleteFavouriteEventSaga(action) {
    const { payload: reqData } = action;
    try {
        yield (0, effects_1.call)(api_1.deleteFavoriteEvents, {
            eventIds: [reqData.eventId],
        });
        yield (0, effects_1.put)(slice_1.favouritesProviderActions.deleteFavouriteEventSuccess());
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while deleting a favourite event', error);
        yield (0, effects_1.put)(slice_1.favouritesProviderActions.deleteFavouriteEventError({
            errorData: error,
            reqData,
        }));
    }
}
// TODO necessary to replace by query fn and save order of events
function* deleteFavouriteEventsByIdsSaga(action) {
    const { payload: reqData } = action;
    try {
        if (!reqData.eventIds.length) {
            throw Error("array of ids shouldn't be empty");
        }
        yield (0, effects_1.call)(api_1.deleteFavoriteEvents, reqData);
        yield (0, effects_1.put)(slice_1.favouritesProviderActions.deleteFavouriteEventsByIdsSuccess());
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while deleting a favourite events by ids', error);
        yield (0, effects_1.put)(slice_1.favouritesProviderActions.deleteFavouriteEventsByIdsError({
            errorData: error,
            reqData,
        }));
    }
}
function* deleteFavouriteEventsSaga() {
    try {
        yield (0, effects_1.call)(api_1.deleteFavoriteEvents);
        yield (0, effects_1.put)(slice_1.favouritesProviderActions.deleteFavouriteEventsSuccess());
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while deleting a favourite event', error);
        yield (0, effects_1.put)(slice_1.favouritesProviderActions.deleteFavouriteEventsError({
            errorData: error,
        }));
    }
}
function* favouritesProviderSaga() {
    yield (0, effects_1.all)([
        (0, effects_1.takeLatest)(slice_1.favouritesProviderActions.fetchFavouriteEventsIds.type, fetchFavouriteEventsIdsSaga),
        (0, effects_1.takeLatest)(slice_1.favouritesProviderActions.createFavouriteEvent.type, createFavouriteEventSaga),
        (0, effects_1.takeLatest)(slice_1.favouritesProviderActions.deleteFavouriteEvent.type, deleteFavouriteEventSaga),
        // To handle favourites events creation properly
        (0, effects_1.takeLatest)(slice_1.favouritesProviderActions.createFavouriteEventSuccess.type, fetchFavouriteEventsIdsSaga),
        (0, effects_1.takeLatest)(slice_1.favouritesProviderActions.createFavouriteEventError.type, fetchFavouriteEventsIdsSaga),
        // To handle favourites events removal properly
        (0, effects_1.takeLatest)(slice_1.favouritesProviderActions.deleteFavouriteEventSuccess.type, fetchFavouriteEventsIdsSaga),
        (0, effects_1.takeLatest)(slice_1.favouritesProviderActions.deleteFavouriteEventError.type, fetchFavouriteEventsIdsSaga),
        (0, effects_1.takeLatest)(slice_1.favouritesProviderActions.deleteFavouriteEvents.type, deleteFavouriteEventsSaga),
        (0, effects_1.takeLatest)(slice_1.favouritesProviderActions.deleteFavouriteEventsSuccess.type, fetchFavouriteEventsIdsSaga),
        (0, effects_1.takeLatest)(slice_1.favouritesProviderActions.deleteFavouriteEventsByIds.type, deleteFavouriteEventsByIdsSaga),
    ]);
}
//# sourceMappingURL=saga.js.map